import usersTypes from './usersTypes';

export const INITIAL_STATE = {
    error: false,
    fetching: false,
    latestCheck: null,
    token: localStorage.getItem('token'),
    rS: localStorage.getItem('rS'),
};

const usersReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case usersTypes.SET_LAST_STATE_CHECK: {
            return {
                ...state,
                latestCheck: action.payload.dateOfCheck,
            };
        }
        case usersTypes.LOGIN_START:
        case usersTypes.CREATE_START: {
            return { ...state, error: false, fetching: true };
        }

        case usersTypes.LOGGED_IN:
        case usersTypes.CREATE_SUCCESS: {
            return {
                ...state,
                error: false,
                fetching: false,
                token: action.payload.token,
                rS: action.payload.roles,
            };
        }

        case usersTypes.CREATE_FAILURE:
        case usersTypes.LOGIN_FAILURE: {
            return {
                ...state,
                fetching: false,
                error: action.payload,
            };
        }

        case usersTypes.LOGOUT: {
            return {
                ...state,
                currentUser: null,
                token: null,
            };
        }

        default:
            return state;

    }
};

export default usersReducer;